var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "access-code-prompt",
    on: {
      "click": _vm.cancel
    }
  }, [_c('div', {
    staticClass: "access-code-prompt__panel",
    class: {
      'access-code-prompt__panel--shake': _vm.isShaking
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._m(0), _c('div', {
    staticClass: "access-code-prompt__display"
  }, [_vm._v("\n      " + _vm._s(_vm.maskedCode) + "\n    ")]), _c('div', {
    staticClass: "access-code-prompt__keys"
  }, [_vm._l(_vm.keys, function (key) {
    return _c('button', {
      key: key,
      staticClass: "touch",
      on: {
        "click": function click($event) {
          return _vm.addKey(key);
        }
      }
    }, [_vm._v("\n        " + _vm._s(key) + "\n      ")]);
  }), _c('button', {
    staticClass: "touch",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Back")]), _c('button', {
    staticClass: "touch",
    on: {
      "click": function click($event) {
        return _vm.addKey('0');
      }
    }
  }, [_vm._v("0")]), _c('button', {
    staticClass: "touch",
    on: {
      "click": _vm.clearCode
    }
  }, [_vm._v("Clear")])], 2)])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "access-code-prompt__header"
  }, [_c('p', [_vm._v("Enter the access PIN to continue.")])]);

}]

export { render, staticRenderFns }